module.exports = __webpack_public_path__ + "static/media/3.ae129042.png";